module.exports = __webpack_public_path__ + "img/glp.fa4cab3e.svg";